import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { GlobalErrorView } from '@bingads-webui-react/app-global-error-view';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const DefaultErrorView = ({ errorViewMode }) => {
  const i18n = useContext(I18nContext);

  if (errorViewMode === 'componentMode') {
    return null;
  }

  const title = i18n.getString(_TL_('Well, that\'s unexpected'));
  const description = [
    i18n.getString(_TL_("This website isn't available right now, but everything should be back to normal very soon.")),
    () => <a href={window.location.href}>{i18n.getString(_TL_('Refresh Page'))}</a>,
  ];

  const errorViewProps = {
    className: 'campaign-ui-error-page',
    title,
    description,
  };
  return <GlobalErrorView {...errorViewProps} />;
};

DefaultErrorView.propTypes = {
  errorViewMode: PropTypes.string,
};

DefaultErrorView.defaultProps = {
  errorViewMode: 'componentMode',
};
